import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import {
  createPhaseAppointment,
  phaseAppointmentClearValidation,
} from 'actionCreators/appointments';
import SchedulePhaseAppointment from 'schedulePhaseAppointment';

class NewPhaseAppointment extends React.Component {
  componentWillMount = () => this.props.phaseAppointmentClearValidation();

  processSubmit = (phaseId, params, ssData, event) =>
    this.props.createPhaseAppointment(phaseId, params, ssData, event);

  render = () => (<SchedulePhaseAppointment
    onSubmit={this.processSubmit}
    errors={this.props.appointmentState.errors}
  />);
}

NewPhaseAppointment.propTypes = {
  createPhaseAppointment: PropTypes.func.isRequired,
  phaseAppointmentClearValidation: PropTypes.func.isRequired,
  appointmentState: PropTypes.shape({
    loading: PropTypes.bool,
    errors: PropTypes.object,
  }),
};

export default connect(state => ({ appointmentState: state.appointment }),
  { createPhaseAppointment, phaseAppointmentClearValidation })(NewPhaseAppointment);



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/phases/phaseShow/tabs/phaseAppointments/components/newPhaseAppointment.jsx